import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("phc_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("phc_token", data.token);
      localStorage.setItem("phc_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("phc_token");
    localStorage.removeItem("phc_user");
    setUser(null);
  }, []);

  useEffect(() => {
    // Silent refresh of /auth/me if token exists
    if (localStorage.getItem("phc_token") && !user) {
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("phc_user", JSON.stringify(r.data));
      }).catch(() => {});
    }
  }, [user]);

  return (
    <AuthCtx.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
